import { HttpClientPlugin } from '../types';
import { getSelfUrl } from '@/src/lib/http/utils/get-self-url';

export function createWithSelfUrlPlugin(): HttpClientPlugin {
  return {
    async beforeRequest(url, options) {
      return { url: getSelfUrl(`api/${url.replace(/^\//, '')}`), options };
    },
  };
}
